// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__Sidebar__base","container":"cms__Sidebar__container","rounded":"cms__Sidebar__rounded","depth":"cms__Sidebar__depth","clearfix":"cms__Sidebar__clearfix","root":"cms__Sidebar__root","sidebar":"cms__Sidebar__sidebar","heading":"cms__Sidebar__heading","nav":"cms__Sidebar__nav","linkWrapper":"cms__Sidebar__linkWrapper","viewEntriesLink":"cms__Sidebar__viewEntriesLink","createEntryLink":"cms__Sidebar__createEntryLink"};


//////////////////
// WEBPACK FOOTER
// ./containers/Sidebar.css
// module id = 261
// module chunks = 0